import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { useEffect, useState, useRef } from 'react'; 
import { MenuItem } from '@mui/material';

const TableAutocompleteCopy = ({tag, objKey, list, setList, count, length, optionsList, width, font, showError, nullifyEmpty}) => {
    // initialize state
    const [value, setValue] = useState(null); 
    // initialize ref
    const ref = useRef();

    // set width if not passed as prop
    if (width == null){
        width = '16.6vw';
    }

    // set font size if given as prop, else use default
    let style = {};
    if (font){ 
        style['fontSize'] = font; 
    }

    // return null if empty string
    const nullIfEmpty = ( str ) => {
        if (str != null && str.length == 0){
            return null; 
        }
        else {
            return str; 
        }
    }

    // event hander to change state variable when a dropdown value is click
    const onInputChange = (e, values) => {
        setValue(value => value = values);
        // set object in list with value
        if (list[count]['blank'] == false) {
            let temp = list; 
            if (nullifyEmpty) {
                temp[count][objKey] = nullIfEmpty(values);
            }
            else {
                temp[count][objKey] = values;
            } 
            setList(list => list = temp );
            console.log(temp); 
        }
    }

    // event handler to change state variable when textfield changes
    const onTextFieldChange = (e) =>{
        setValue(value => value = e.target.value);
        // set object in list with value
        if (list[count]['blank'] == false) {
            let temp = list; 
            if (nullifyEmpty) {
                temp[count][objKey] = nullIfEmpty(e.target.value); 
            }
            else {
                temp[count][objKey] = e.target.value; 
            }
            setList(list => list = temp );
            console.log(temp); 
        }
    }

    // event handler to clear state variable when clear is clicked
    const onClear = () => {
        setValue(value => value = '');
        // set object in list with value
        if (list[count]['blank'] == false) {
            let temp = list; 
            temp[count][objKey] = ''; 
            setList(list => list = temp );
            console.log(temp); 
        }
    }

    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 

    // useEffect to on list length change 
    useEffect(() => {
        if (list[count]) {
            setValue(value => value = list[count][objKey]); 
        }
    }, [length]); 

    return (
        // material ui autocomplete component
        <FormControl fullWidth size='small' sx={{ width: width ,maxWidth: width}} >
            <AutoComplete
                id="combo-box-demo"
                options={ optionsList }
                size='small'
                value={value}      
                renderInput={(params) => 
                    <TextField 
                        sx={{ width: width, maxWidth: width, "& .MuiInputBase-input": {
                            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: '400'
                            },
                            '& ::placeholder': {
                            fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: '400'
                        },}} 
                        {...params} 
                        style={style} 
                        InputProps={{ ...params.InputProps, style: style }} 
                        InputLabelProps={{style: style}} 
                        placeholder={`Search ${tag}`} 
                        onChange={(e)=>onTextFieldChange(e)}
                        error={error}
                        inputRef={ref}
                    />
                }
                renderOption={(props, option) => 
                    <MenuItem 
                        sx={{whiteSpace:"collapse","&.Mui-selected": {
                            backgroundColor: "#E6EDF1",
                        },
                        "&.Mui-selected:focus": {
                            backgroundColor: "#E6EDF1",
                        },
                        "&.MuiMenuItem-root": {
                            fontSize: "14px",
                            borderBottom: "1px solid #E6EDF1",
                            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
                        },}} 
                    {...props} style={style}>{option}</MenuItem>
                }
                onChange={(e, values)=>onInputChange(e, values)}
                onClear={()=>onClear()}
                disableClearable 
            />
        </FormControl>
    );
}

export default TableAutocompleteCopy;
